import { render, staticRenderFns } from "./CrearNuevoCupDialogComponent.vue?vue&type=template&id=23194034&scoped=true"
import script from "./CrearNuevoCupDialogComponent.vue?vue&type=script&lang=js"
export * from "./CrearNuevoCupDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./CrearNuevoCupDialogComponent.vue?vue&type=style&index=0&id=23194034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23194034",
  null
  
)

export default component.exports